export default __webpack_public_path__ + "static/media/hero-promo-banner.97ab4376.svg";